export const SignupPrice = {
  transclude: true,

  bindings: {
    priceInCents: '<value',
  },

  template: `
    <div class="signup-price">
      <span class="dollars"><span>$</span>{{ $ctrl.dollars }}</span>.{{ $ctrl.cents }}<ng-transclude></ng-transclude>
    </div>`,

  controller() {
    'ngInject';

    return {
      $onChanges({ priceInCents }) {
        if (priceInCents.currentValue) {
          const parts = (priceInCents.currentValue / 100).toString().split('.');
          this.dollars = parts[0];
          this.cents = parts[1];
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupPrice.js